module.exports = __webpack_public_path__ + "img/dqnm.a78f1def.png";